import { createClient } from '@supabase/supabase-js';

// Placeholder values let the app boot in CI when E2E secrets are not configured.
// Real requests fail fast; public UI and auth redirects still work.
const PLACEHOLDER_SUPABASE_URL = 'https://e2e-placeholder.invalid';
const PLACEHOLDER_ANON_KEY = 'e2e-placeholder-anon-key';

const supabaseUrl = process.env.VUE_APP_SUPABASE_URL || PLACEHOLDER_SUPABASE_URL;
const supabaseAnonKey = process.env.VUE_APP_SUPABASE_ANON_KEY || PLACEHOLDER_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
